import { AssetClassEnum } from '../../../../../../../api/useDefaultAssetAllocationQuery';

export interface Allocation {
  total: number;
  allocation: { [key in AssetClassEnum]?: number }; // 0 <= number <= 1
}

export const getWeightedAllocation = (allocations: Allocation[]) => {
  if (!allocations || allocations.length === 0) {
    throw new Error('No allocations provided');
  }

  const filteredAllocations = allocations.filter(({ total }) => total > 0);

  if (filteredAllocations.length === 0) {
    return null;
  }

  const totalValue = filteredAllocations.reduce((acc, { total }) => acc + total, 0);

  const weightedTotals = filteredAllocations.reduce((acc, { allocation, total }) => {
    Object.entries(allocation).forEach(([assetClassId, percent]) => {
      if (acc[assetClassId]) {
        acc[assetClassId] += total * percent;
      } else {
        acc[assetClassId] = total * percent;
      }
    });

    return acc;
  }, {} as { [key in AssetClassEnum]?: number });

  return Object.entries(weightedTotals).reduce((acc, [assetClassId, value]) => {
    acc[assetClassId] = value / totalValue;

    return acc;
  }, {});
};
